import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Logo from "@/assets/icons/Logos/Logo - Web.svg";
import { MenuOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input } from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import MobileLogo from "@/assets/icons/Logos/Logo.svg";
import MessageIcon from "@/assets/icons/web_Icons/message-text-2.svg";
import MenuIcon from "@/assets/icons/web_Icons/component_2.svg";
import BellIcon from "@/assets/icons/web_Icons/notification.svg";
import { useState } from "react";
import { SlideOutMenu } from "@/components/layout/Header/Slide_Out_Menu";

const Navbar = ({ respondentDisplay }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const handleMenuClick = () => {
    setMenuVisible(false);
  };
  ``;
  return (
    <div className="p-2 max-w-[1500px] mx-auto">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-5">
          <img src={Logo} alt="" className="hidden lg:block w-80" />
          <div className="flex items-center gap-2">
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMenuVisible(true)}
              className="p-0 menu-button text-primary lg:hidden"
              aria-label="Menu"
            />
            <div className="logo-container lg:hidden">
              <img src={MobileLogo} alt="Veegil Logo" className="" />
            </div>
          </div>
          <ul className="items-center gap-5 text-[#333333] text-[13px] w-full hidden lg:flex">
            <li>
              <Link to={""}>Debate</Link>
            </li>
            <li>
              <Link to={""}>Veralog</Link>
            </li>
            <li>
              <Link to={""}>Election Monitoring</Link>
            </li>
          </ul>
          <Input
            placeholder="Search"
            prefix={<SearchOutlined className="text-[#eee]" />}
            className="hidden w-2/3 text-black rounded-md lg:flex"
          />
        </div>
        <div className="flex items-center gap-5">
          <div className="items-center hidden gap-3 lg:flex">
            <div className="flex items-center justify-center w-8 h-8 bg-gray-100 rounded-xl">
              <img src={BellIcon} className="w-6 h-6" />
            </div>
            <div className="flex items-center justify-center w-8 h-8 bg-gray-100 rounded-xl">
              <img src={MessageIcon} className="w-6 h-6" />
            </div>
          </div>
          <Avatar
            src={respondentDisplay.avatar}
            alt={respondentDisplay.name}
            size={40}
          />
          <img src={MenuIcon} alt="" className="hidden lg:flex" />
        </div>
      </div>
      <SlideOutMenu
        visible={menuVisible}
        onClose={() => setMenuVisible(false)}
        onMenuClick={handleMenuClick}
      />
    </div>
  );
};

Navbar.propTypes = {
  respondentDisplay: PropTypes.shape({
  name: PropTypes.string,
  avatar: PropTypes.string,
  role: PropTypes.string,
}).isRequired,
};

export default Navbar;
